// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","tablet-landscape-up":"(min-width: calc(1024 * 1px))","item":"ItemStore_item__3Cgs4"};